import { render, staticRenderFns } from "./InviteTeammatesAtlassian.vue?vue&type=template&id=040025ef"
import script from "./InviteTeammatesAtlassian.vue?vue&type=script&lang=js"
export * from "./InviteTeammatesAtlassian.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports